import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['YardOut', 'DispatchBoards', 'YardOutFrom'],
});
export const yardoutApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllYardOuts: builder.query({
      query: () => `yardouts/`,
      providesTags: ['YardOut'],
    }),
    findYardOutById: builder.query({
      query: (id) => `yardouts/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'YardOut', id: result.id }] : ['YardOut'];
      },
    }),
    findCheckMatchVin: builder.query({
      query: (payload) => {
        let url = `yardout/check_match/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['YardOut'],
    }),

    findYardOutTrailerbyCardId: builder.query({
      query: (trailer_card_id) =>
        `trailers/?trailer_card_id=${trailer_card_id}`,
      // keepUnusedDataFor: 0, // No cache
      providesTags: ['YardOut'],
      // providesTags: (result, error, arg) => {
      //   debugger
      //   return result ? [{ type: 'YardOut', id: result.id }] : ['YardOut'];
      // },
    }),

    findYardOutDriverbyCode: builder.query({
      query: (tlep_code) => `drivers/?tlep_code=${tlep_code}`,
      providesTags: ['YardOut'],
    }),

    findCurrentTimeYardOut: builder.query({
      query: () => `server_time/`,
      keepUnusedDataFor: 0,
      providesTags: ['YardOut'],
    }),

    findYardOutConfirm: builder.query({
      query: (payload) => {
        let url = `yardout/confirm/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['YardOut'],
    }),

    updateYardOutDispatchBoards: builder.mutation({
      query: (payload) => ({
        url: `dispatch_boards/${payload.id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['DispatchBoards'],
    }),

    createYardOut: builder.mutation({
      query: (yardout) => ({
        url: `yardout/save/`,
        method: 'POST',
        body: yardout,
      }),
      invalidatesTags: ['YardOutFrom'],
    }),
    updateYardOut: builder.mutation({
      query: (yardout) => ({
        url: `yardouts/${yardout.id}/`,
        method: 'PATCH',
        body: yardout,
      }),
      invalidatesTags: ['YardOut'],
    }),
    upsertYardOut: builder.mutation({
      query: (yardout) => ({
        url: `yardouts/upsert/`,
        method: 'POST',
        body: yardout,
      }),
      invalidatesTags: ['YardOut'],
    }),
    deleteYardOut: builder.mutation({
      query: (yardout) => ({
        url: `yardouts/${yardout.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['YardOut'],
    }),
    findYardOutReasonMasterByModule: builder.query({
      query: (module) => `reasons/?module__name=${module}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'YardOut', module: result.module }]
          : ['YardOut'];
      },
    }),
    findYardOutGroupReasonByCode: builder.query({
      query: (code) => `reasons/?&subject_reason__group__code=${code}`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'YardOut', id: result.id }] : ['YardOut'];
      },
    }),
    findParkingsClear: builder.query({
      query: (payload) => {
        let url = `parkings_clear/calling_vins/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
    }),
    findYardOutTrailerLaneById: builder.query({
      query: (dispatch_board_id) =>
        `receive_jobs/trailer_lane/?dispatch_board_id=${dispatch_board_id}`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'YardOut', id: result.id }] : ['YardOut'];
      },
    }),
    updateYardOutTrailerLane: builder.mutation({
      query: (type) => ({
        url: `lanes/${type.id}/`,
        method: 'PATCH',
        body: type,
      }),
      invalidatesTags: ['YardOut'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllYardOutsQuery,
  useFindYardOutByIdQuery,
  useCreateYardOutMutation,
  useUpdateYardOutMutation,
  useDeleteYardOutMutation,
  useFindCurrentTimeYardOutQuery,
  useUpdateYardOutDispatchBoardsMutation,
  useFindYardOutReasonMasterByModuleQuery,
} = yardoutApi;
